import { useMemo as C } from "react";
import { useTranslation as T } from "react-i18next";
import { getCurrentLanguage as M } from "../../i18n/i18n.js";
import { useAuth as P } from "../../auth/hooks/useAuth.js";
import { ActionButtonsType as r } from "../../../pages/landing/shared/actions.enum.js";
import { useSharedLanding as x } from "../../../pages/landing/SharedLanding/hooks/useSharedLanding/useSharedLanding.js";
import { GoogleAnalytics as D } from "../../../../js/analytics/google/index.js";
import { useNavigation as K } from "../components/Navigation/hooks/useNavigation.js";
function j(v, S, o = {}, E) {
  const {
    customer: f,
    login: I
  } = P(), {
    openModal: m,
    closeModal: _
  } = x(), {
    navigate: h
  } = K(), i = E ?? h, {
    t: u
  } = T(), A = C(() => new URL((window == null ? void 0 : window.location.href) ?? ""), [
    window == null ? void 0 : window.location.href.toString()
  ]), L = (e, n) => {
    switch (e) {
      case r.PORTAL_LINK:
        return () => I();
      case r.LOYALTY_LINK:
        return () => i("/loyalty", {
          overrideHistory: o.overrideHistory
        });
      case r.STAMP_CARDS:
        return () => i("/stamp-cards", {
          overrideHistory: o.overrideHistory
        });
      case r.REWARDS_LINK:
        return () => i("/rewards", {
          overrideHistory: o.overrideHistory
        });
      case r.CUSTOM_LINK:
        return n.content;
      case r.ORDER_HISTORY:
        return () => i("/orders", {
          overrideHistory: o.overrideHistory
        });
      case r.PROFILE:
        return () => i("/profile", {
          overrideHistory: o.overrideHistory
        });
      case r.PAYMENT_METHODS:
        return () => i("/payment-methods", {
          overrideHistory: o.overrideHistory
        });
      case r.CASHBACK:
        return () => i("/my-cashback", {
          overrideHistory: o.overrideHistory
        });
      case r.REDIRECT_ACTION:
        return async () => {
          var d;
          const t = A.searchParams.get(((d = n.content) == null ? void 0 : d.toString()) ?? "");
          if (t === null || window === void 0)
            return;
          const a = await D.appendAnalyticsToUrl(t, o == null ? void 0 : o.utmReferral);
          window.location.href = a.toString();
        };
      case r.FETCH_ACTION:
        return () => {
          (async () => {
            var R, H;
            const t = (H = (R = window.fetchActions) == null ? void 0 : R.translations) == null ? void 0 : H[M()];
            function a(l, s = "unknown") {
              return u(l).replace("{status}", s);
            }
            async function d() {
              var l;
              try {
                const s = A.searchParams.get(((l = n.content) == null ? void 0 : l.toString()) ?? "");
                if (!s) return;
                const N = await fetch(s);
                let y = "error";
                const { status: c } = N;
                c < 300 ? y = "2xx" : c >= 300 && c < 400 && (y = "3xx"), m({
                  title: (t == null ? void 0 : t[`status${c}Title`]) ?? a(`shopLanding.fetchAction.${y}.title`, c.toString()),
                  content: (t == null ? void 0 : t[`status${c}Text`]) ?? a(`shopLanding.fetchAction.${y}`, c.toString())
                });
              } catch (s) {
                m({
                  title: (t == null ? void 0 : t.unknownErrorTitle) ?? a("shopLanding.fetchAction.error.title"),
                  content: (t == null ? void 0 : t.unknownErrorText) ?? a("shopLanding.fetchAction.error")
                }), console.error(s);
              }
            }
            m({
              title: (t == null ? void 0 : t.confirmationTitle) ?? u("shopLanding.fetchAction.confirmation.title"),
              content: (t == null ? void 0 : t.confirmationText) ?? u("shopLanding.fetchAction.confirmation.body"),
              button: {
                accept: {
                  text: (t == null ? void 0 : t.confirmationButtonAccept) ?? u("shopLanding.fetchAction.confirmation.accept"),
                  action: d
                },
                cancel: {
                  text: (t == null ? void 0 : t.confirmationButtonCancel) ?? u("shopLanding.fetchAction.confirmation.cancel"),
                  action: _
                }
              }
            });
          })();
        };
      case r.ORDER_LINK:
      case r.PAY_LINK:
        return n.content;
      default:
        return;
    }
  }, g = (e) => {
    const n = [
      r.LOYALTY_LINK,
      r.STAMP_CARDS,
      r.REWARDS_LINK
    ];
    return f ? f.activity.loyalty ? ![
      r.PORTAL_LINK
    ].includes(e.type) : !n.includes(e.type) : ![
      ...n,
      r.ORDER_HISTORY,
      r.PROFILE,
      r.PAYMENT_METHODS
    ].includes(e.type);
  }, p = (e) => {
    var t;
    return [r.FETCH_ACTION, r.REDIRECT_ACTION].includes(e.type) ? A.searchParams.get(((t = e.content) == null ? void 0 : t.toString()) ?? "") !== null : !0;
  }, w = v.filter(g).filter(p).map((e) => ({
    action: L(e.type, e),
    text: e.text,
    icon: e.icon,
    primary: e.primary
  })), O = S.filter(g).filter(p).map((e) => ({
    action: L(e.type, e),
    text: e.text
  })) ?? [];
  return {
    actionButtons: w,
    actionLinks: O
  };
}
export {
  j as useAction
};
//# sourceMappingURL=useAction.js.map
